import React from 'react';
import { LockIcon } from 'lucide-react';
export function RestrictedState() {
  return <div className="flex flex-col items-center justify-center py-16 px-4 text-center" data-id="element-117">
      <div className="bg-[#FCEEEF] p-4 rounded-full mb-4" data-id="element-118">
        <LockIcon className="w-8 h-8 text-[#BA0517]" aria-hidden="true" data-id="element-119" />
      </div>
      <h3 className="text-lg font-semibold text-[#181818] mb-2" data-id="element-120">
        Access Restricted
      </h3>
      <p className="text-sm text-[#444444] max-w-md" data-id="element-121">
        You do not have permission to view secure documents for this
        opportunity. Contact your administrator for access.
      </p>
    </div>;
}